// App.js
import { NavigationProvider } from "./context/NavigationContext";
import { useActiveSection } from "./hooks/useActiveSection";

import Hero from "./components/Hero";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import WhatsAppWidget from "./components/WhatsAppWidget";
import Footer from "./components/Footer";
import PartnerSection from "./components/PartnerSection";
import ProductCarousel from "./components/ProductCarousel";
// import ImageSlider from "./components/ImageSlider";
import ContactUsSection from "./components/Contact";
import Navbar from "./components/Header";

const AppContent = () => {
  useActiveSection();

  return (
    <div className="App">
      {/* Hero Section */}
      <section id="home" data-section="home">
        <div className="hero_area">
          <Navbar />
          <div className="bg-box">
            <img src="images/hero.webp" alt="Background" style={{ objectFit: 'fill' }} />
          </div>
          <Hero />
        </div>
      </section>

      {/* Services Section */}
      <section id="services" data-section="services">
        <ServicesSection />
      </section>

      {/* products Section */}
      <section id="products" data-section="products">
        {/* <ProductCarousel /> */}
      </section>

      {/* products Section */}
      {/* <section id="" data-section="products">
        <ImageSlider />
      </section> */}

      {/* About Section */}
      <section id="about" data-section="about">
        <AboutSection />
      </section>

      {/* About Section */}
      {/* <section id="partners" data-section="partners">
        <PartnerSection />
      </section> */}

      {/* Booking Section */}
      <section id="contact" data-section="book">
        <ContactUsSection />
      </section>

      <Footer />

      {/* زر واتساب */}
      <WhatsAppWidget />
    </div>
  );
};

function App() {
  return (
    <NavigationProvider>
      <AppContent />
    </NavigationProvider>
  );
}

export default App;
